import { render } from "./knowledge_detail.vue?vue&type=template&id=4bc351ea&scoped=true"
import script from "./knowledge_detail.vue?vue&type=script&lang=js"
export * from "./knowledge_detail.vue?vue&type=script&lang=js"

import "./knowledge_detail.vue?vue&type=style&index=0&id=4bc351ea&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc351ea"]])

export default __exports__